// Here we can define any theme that follows the CustomThemeInterface type from @atbay/theming
export const theme = {
    colors: {
        primary: {
            40: '#F5F9FF',
            50: '#CCDAFF',
            100: '#D9EBFF',
            200: '#2020EE',
            300: '#5489FF',
            400: '#3C64FF',
            500: '#2A41F8',
            600: '#2020EE',
            700: '#1217C2',
            800: '#09109E',
            900: '#00005F',
            950: '#002050',
        },
        greys: {
            0: '#FFFFFF',
            50: '#FCFCFC',
            75: '#F8F8F8',
            100: '#F2F2F2',
            200: '#E6E6E6',
            300: '#CCCCCC',
            400: '#AFAFAF',
            500: '#919191',
            600: '#696969',
            700: '#4C4C4C',
            800: '#191919',
            900: '#010101',
        },
        reds: {
            0: '#F02A26', // Main red
            100: '#FBF3F3', // Light red (backgrounds, errorLight)
            200: '#F02A261A', // Transparent red (statusOpenLight)
            300: '#EB100040', // Transparent red (securityScoreError)
            400: '#EB1000', // Error, alertCritical, SVGs
            500: '#B91714', // Dark red (incident text)
            600: '#A41512', // SVGs, dark theme error
            700: '#952424', // SCSS, dark red border
            800: 'rgba(164, 21, 18, 0.05)', // caseLightRed, backgrounds
            900: 'rgba(185, 23, 20, 0.25)', // caseLightRedBorder
            950: '#FFDEDE59', // Transparent light red (reason)
        },
        greens: {
            100: '#E6F7E9',
            600: '#07AF26',
            800: '#07AF26',
        },
        yellows: {
            900: '#FFED1E',
        },
        teals: {
            900: '#14979D',
            800: '#68EEF7',
        },
        semantic: {
            securityTrainingText: '#191919',
            securityTraining: '#CCDAFF',
            success: '#00BF30',
            successLight: '#B6FFC5',
            successLighter: '#F0FFF3',
            successDark: '#14942a',
            moderate: '#EADB03',
            moderateLight: '#FFF7B6',
            warning: '#FF7B00',
            warningLight: '#FFD9B6',
            error: '#EB1000',
            errorLight: '#FFDEDE',
            severityBadgeCriticalText: '#A41512',
            severityBadgeCriticalBorder: '#FFB8B7',
            severityBadgeCriticalBackground: '#FFEFEF',
            severityBadgeImportantText: '#FF7B00',
            severityBadgeImportantBorder: '#FFCEA1',
            severityBadgeImportantBackground: '#FFEBD9',
            severityBadgeModerateText: '#998E12',
            severityBadgeModerateBorder: '#FFF478',
            severityBadgeModerateBackground: '#FFFBD2',
            severityBadgeLowText: '#2A41F8',
            severityBadgeLowBorder: '#B9C7FF',
            severityBadgeLowBackground: '#EAF0FF',
            severityBadgeInfoText: '#696969',
            severityBadgeInfoBorder: '#CCCCCC',
            severityBadgeInfoBackground: '#F2F2F2',
            successBackground: '#F2F2F2',
            neutral: '#eee',
            dark: '#000',
            separator: '#FFFFFF',
            gradientTop: '#E6E6E6',
            gradientBottom: '#E6E6E600',
            background: '#F5F8FC',
            backgroundSecondary: '#FFFFFF',
            drawerBackground: '#FFFFFF',
            simpleMenu: '#FFFFFF',
            sideBarSlider: '#CCDAFF',
            sideBarActivate: '#191919',
            tabActivate: '#191919',
            contentSeparator: '#CCCCCC',
            drawerSeparator: '#E6E6E6',
            topPageSeparator: '#CCDAFF',
            dialogHeader: '#FFFFFF',
            filterReset: '#FFFFFF',
            muiCheckedBackground: '#CCDAFF',
            muiTrackBackground: '#CCDAFF',
            muiUnCheckedBackground: '#F2F2F2',
            muiUnCheckedLightBackground: '#FFFFFF',
            summaryIndicator: '#F2F2F2',
            filterUnActive: '#FFFFFF',
            secondarySeparator: '#CCDAFF',
            tag: '#F2F2F2',
            validDomain: '#CCDAFF',
            inValidDomain: '#FFDEDE',
            inValidCloseBtn: '#FFF',
            validCloseBtn: '#FFF',
            securityScoreSuccess: '#00BF3033',
            securityScoreModerate: '#E1D70366',
            securityScoreWarning: '#FF6C004D',
            securityScoreError: '#EB100040',
            liveAnimation: 'rgba(32, 32, 238, 0.6)',
            issueLabel: '#AFAFAF',
            selectedIssueCategories: '#191919',
            sendNewInvitationBackground: '#002050',
            sendNewInvitationBackgroundSecondary: '#FFFFFF',
            sendNewInvitationText: '#191919',
            reason: '#FFDEDE59',
            statusResolvedLight: '#04C4261A',
            statusOpenLight: '#F02A261A',
            caseLightGreen: '#F0FFF3',
            caseLightGreenBorder: 'rgba(7, 175, 38, 0.50)',
            caseLightRed: 'rgba(164, 21, 18, 0.05)',
            caseLightRedBorder: 'rgba(185, 23, 20, 0.25)',
            openCasesTypeIncidentTextColor: '#A41512',
            openCasesTypeIncidentBackgroundColor: 'rgba(164, 21, 18, 0.05)',
            openCasesTypeServiceRequestTextColor: '#00005F',
            openCasesTypeServiceRequestBackgroundColor:
                'rgba(204, 218, 255, 0.29)',
            openCasesBackground: '#F8F8F8',
            openCasesBorder: '#E6E6E6',
            alertCritical: '#EB1000',
            alertHigh: '#FF7B00',
            alertMedium: '#FFED1E',
            alertLow: '#999999',
            alertInfo: '#CDCECD',
            gridColor: 'rgba(0, 0, 0, 0.1)',
            demoAccountBanner: '#E6E6E6',
            alertsOverTimeGradientTop: '#D9EBFF',
            alertsOverTimeGradientBottom: '#FCFCFC',
            googleAndMicrosoftIcon: '#FCFCFC',
            inputBorder: '#D1D5DB',
            mdrDemoOverlay: 'rgba(248, 248, 248, 0.80)',
            sideBarBackground: '#002050',
            sidebarText: '#FFFFFF',
            headerBorder: 'transparent',
            headerShadow: 'rgba(0, 0, 0, 0.2)',
            tableScrollShadow: 'rgba(0, 0, 0, 0.05)',
            filterLabelBackground: 'rgba(179, 215, 255, 0.15)',
            primaryText: '#3C64FF',
            primaryTextHover: '#2A41F8',
            tableHeader: '#F6F8FF',
            tableBorder: '#CCDAFF',
            tableActive: '#F6F8FF',
            tableHover: '#F9FBFF',
            filterPopupFooterBackground: '#FFFFFF',
            statusOpenText: '#B42318',
            statusValidatingText: '#4B5563',
            statusResolvedText: '#07AF26',
            statusApprovedText: '#354061',
            statusOpenBackground: 'rgba(240, 42, 38, 0.10)',
            statusValidatingBackground: 'rgba(75, 85, 99, 0.06)',
            statusResolvedBackground: 'rgba(7, 175, 38, 0.10)',
            statusApprovedBackground: 'rgba(53, 64, 97, 0.10)',
            statusOpenBorder: 'rgba(240, 42, 38, 0.30)',
            statusValidatingBorder: 'rgba(75, 85, 99, 0.25)',
            statusResolvedBorder: 'rgba(7, 175, 38, 0.30)',
            statusApprovedBorder: 'rgba(53, 64, 97, 0.25)',
            statusActiveBackground: '#F3FBF4',
            statusBrokenBackground: '#FFDEDE',
            statusActiveText: '#109328',
            statusBrokenText: '#F02A26',
            assetsExportButton: '#667996',
            overviewListItemIconBackground: '#F3F6FF',
            overviewSeparator: '#D9E3FF',
            activationButton: '#3C64FF',
            activationButtonHover: '#2020EE',
            bannerBackgroundWarning: '#F3F6FF',
            bannerBackgroundInfo: '#F1F5F9',
            bannerBackgroundError: '#FCF2F2',
            bannerBorderWarning: '#CCDAFF',
            bannerBorderInfo: '#CCD9E5',
            bannerIconBackground: '#F8F8F8',
            bannerIconBackgroundError: '#FFEBE9',
            bannerIconBorder: '#FFFFFF',
            bannerIconColor: '#191919',
            marketingInfoBannerBackground: '#FFFFFF',
            secondaryButtonColor: '#3C64FF',
            secondaryButtonHoverColor: '#2A41F8',
            markAsResolvedFormBackground: '#FCFCFC',
            seeWhyHoverColor: '#2020EE',
            tableHeaderText: '#002050',
            integrationProviderCardDivider: '#CCD9E5',
            partialActiveIndicator: '#FF7B00',
            partialActiveIndicatorHover: '#D36805',
            contactExpertLink: '#3C64FF',
            contactExpertLinkHover: '#2A41F8',
            integrationCardBoxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
            integrationCardHoverBoxShadow: '0 4px 16px rgba(0, 0, 0, 0.12)',
            integrationCardHoverBorder: '#5489FF',
            integrationCardArrowButtonHover: '#5489FF',
            collapsingBannerBorder: '#FFDEDC',
            collapsingBannerIcon: '#D31D1A',
        },
        toast: {
            background: '#FFFFFF',
            error: '#EB1000',
            success: '#14942a',
            info: '#2020EE',
            warning: '#FF7B00',
        },
        main: '#00005F',
    },
    fonts: {
        'xxxl-light': {
            fontFamily: 'Lato',
            fontWeight: 300,
            fontSize: '5rem',
        },
        'xxxl-regular': {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '5rem',
        },
        'xxxl-medium': {
            fontFamily: 'Lato',
            fontWeight: 500,
            fontSize: '5rem',
        },
        'xxxl-semibold': {
            fontFamily: 'Lato',
            fontWeight: 600,
            fontSize: '5rem',
        },
        'xxxl-bold': { fontFamily: 'Lato', fontWeight: 700, fontSize: '5rem' },
        'xxl-light': {
            fontFamily: 'Lato',
            fontWeight: 300,
            fontSize: '3.2rem',
        },
        'xxl-regular': {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '3.2rem',
        },
        'xxl-medium': {
            fontFamily: 'Lato',
            fontWeight: 500,
            fontSize: '3.2rem',
        },
        'xxl-semibold': {
            fontFamily: 'Lato',
            fontWeight: 600,
            fontSize: '3.2rem',
        },
        'xxl-bold': {
            fontFamily: 'Lato',
            fontWeight: 600,
            fontSize: '3.2rem',
        },
        'xl-light': {
            fontFamily: 'Lato',
            fontWeight: 300,
            fontSize: '2.4rem',
        },
        'xl-regular': {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '2.4rem',
        },
        'xl-medium': {
            fontFamily: 'Lato',
            fontWeight: 500,
            fontSize: '2.4rem',
        },
        'xl-semibold': {
            fontFamily: 'Lato',
            fontWeight: 600,
            fontSize: '2.4rem',
        },
        'xl-bold': { fontFamily: 'Lato', fontWeight: 700, fontSize: '2.4rem' },
        'l-light': { fontFamily: 'Lato', fontWeight: 300, fontSize: '1.8rem' },
        'l-regular': {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '1.8rem',
        },
        'l-medium': {
            fontFamily: 'Lato',
            fontWeight: 500,
            fontSize: '1.8rem',
        },
        'l-semibold': {
            fontFamily: 'Lato',
            fontWeight: 600,
            fontSize: '1.8rem',
        },
        'l-bold': { fontFamily: 'Lato', fontWeight: 700, fontSize: '1.8rem' },
        'm-light': { fontFamily: 'Lato', fontWeight: 300, fontSize: '1.6rem' },
        'm-regular': {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '1.6rem',
        },
        'm-medium': {
            fontFamily: 'Lato',
            fontWeight: 500,
            fontSize: '1.6rem',
        },
        'm-semibold': {
            fontFamily: 'Lato',
            fontWeight: 600,
            fontSize: '1.6rem',
        },
        'm-bold': { fontFamily: 'Lato', fontWeight: 700, fontSize: '1.6rem' },
        's-light': { fontFamily: 'Lato', fontWeight: 300, fontSize: '1.4rem' },
        's-regular': {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '1.4rem',
        },
        's-medium': {
            fontFamily: 'Lato',
            fontWeight: 500,
            fontSize: '1.4rem',
        },
        's-semibold': {
            fontFamily: 'Lato',
            fontWeight: 600,
            fontSize: '1.4rem',
        },
        's-bold': { fontFamily: 'Lato', fontWeight: 700, fontSize: '1.4rem' },
        'xs-light': {
            fontFamily: 'Lato',
            fontWeight: 300,
            fontSize: '1.2rem',
        },
        'xs-regular': {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '1.2rem',
        },
        'xs-medium': {
            fontFamily: 'Lato',
            fontWeight: 500,
            fontSize: '1.2rem',
        },
        'xs-semibold': {
            fontFamily: 'Lato',
            fontWeight: 600,
            fontSize: '1.2rem',
        },
        'xs-bold': { fontFamily: 'Lato', fontWeight: 700, fontSize: '1.2rem' },
        mainSM: {
            fontFamily: 'Lato',
            fontWeight: 200,
            fontSize: '1rem',
        },
        pri10L: {
            fontFamily: 'Lato',
            fontWeight: 200,
            fontSize: '1rem',
        },
        pri12L: {
            fontFamily: 'Lato',
            fontWeight: 200,
            fontSize: '1.2rem',
        },
        pri14L: {
            fontFamily: 'Lato',
            fontWeight: 200,
            fontSize: '1.4rem',
        },
        pri10R: {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '1rem',
        },
        pri12R: {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '1.2rem',
        },
        pri14R: {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '1.4rem',
        },
        pri16R: {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '1.6rem',
        },
        pri18R: {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '1.8rem',
        },
        pri20R: {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '2rem',
        },
        pri24R: {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '2.4rem',
        },
        pri28R: {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '2.4rem',
        },
        pri32R: {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '3.2rem',
        },
        pri10RX: {
            fontFamily: 'Lato',
            fontWeight: 500,
            fontSize: '1rem',
        },
        pri12RX: {
            fontFamily: 'Lato',
            fontWeight: 500,
            fontSize: '1.2rem',
        },
        pri14RX: {
            fontFamily: 'Lato',
            fontWeight: 500,
            fontSize: '1.4rem',
        },
        pri10B: {
            fontFamily: 'Lato',
            fontWeight: 700,
            fontSize: '1rem',
        },
        pri12B: {
            fontFamily: 'Lato',
            fontWeight: 700,
            fontSize: '1.2rem',
        },
        pri14B: {
            fontFamily: 'Lato',
            fontWeight: 700,
            fontSize: '1.4rem',
        },
        pri16B: {
            fontFamily: 'Lato',
            fontWeight: 700,
            fontSize: '1.6rem',
        },
        pri18B: {
            fontFamily: 'Lato',
            fontWeight: 700,
            fontSize: '1.8rem',
        },
        pri20B: {
            fontFamily: 'Lato',
            fontWeight: 700,
            fontSize: '2rem',
        },
        pri24B: {
            fontFamily: 'Lato',
            fontWeight: 700,
            fontSize: '2.4rem',
        },
        pri28B: {
            fontFamily: 'Lato',
            fontWeight: 700,
            fontSize: '2.8rem',
        },
        pri32B: {
            fontFamily: 'Lato',
            fontWeight: 700,
            fontSize: '3.2rem',
        },
        sec10R: {
            fontFamily: 'Pressura',
            fontWeight: 400,
            fontSize: '1rem',
        },
        sec12R: {
            fontFamily: 'Pressura',
            fontWeight: 400,
            fontSize: '1.2rem',
        },
    },
}
